<template>
  <div class="modal-menu mb-2" :class="{ left }" v-if="menus">
    <div class="modal-menu__item"
         :class="{'modal-menu__item--selected': (index + 1) === selected}"
         v-for="(m, index) in menus" v-show="m.active">
      <a class="text-muted" href="javascript:" @click="change(index + 1)">{{m.nome}}</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ModalMenu',
    props: ['menus','selected', 'left'],
    methods: {
      change(index) {
        this.$emit('changeMenu', index)
      }
    }
  }
</script>
<style>
.modal-menu {
  border-bottom: 1px solid rgba(0,0,0,.1);
  display: flex;
  text-align: center;
  justify-content: space-around;
}

.modal-menu.left {
  text-align: left;
  justify-content: left;
}

.modal-menu__item {
  display: inline-block;
  margin-right: 22px;
  padding: 0;
  text-align: center;
  font-size: 16px;
  margin-bottom: 12px;
}

.modal-menu__item a:hover, a:visited {
  text-decoration: none;
}

.modal-menu__item--selected {
  border-bottom: 2px solid;
  border-color: var(--lecard-primary);
  font-weight: 500;
}

.modal-menu__item--selected a {
  color: var(--lecard-primary)!important;
}
</style>
